import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./floor-create-draw-prompt.module.scss";
import PinnedListHeader from "../pinned-list-header";
import PinnedList from "../pinned-list";
import { classArr } from "../../../../helper/style-helper";
import IconFloorplan2D from "../../../../dynamicicons/icon-floorplan-2d";
import IconFloorplan3D from "../../../../dynamicicons/icon-floorplan-3d";
import VelavuButton from "../../../../elements/velavu-button";

export type FloorCreateDrawPromptSelection = "image" | "draw";

export interface FloorCreateDrawPromptProps {
	onClose?: () => void;
	onNext?: (selection: FloorCreateDrawPromptSelection) => void;
	disableNext?: boolean;
}

export default function FloorCreateDrawPrompt(
	props: FloorCreateDrawPromptProps,
) {
	const { t } = useTranslation();
	const [selection, setSelection] =
		useState<FloorCreateDrawPromptSelection | null>(null);

	const propsOnNext = props.onNext;
	const handleSubmit = useCallback(() => {
		if (selection === null) {
			return;
		}

		propsOnNext?.(selection);
	}, [selection, propsOnNext]);

	return (
		<PinnedList>
			<PinnedListHeader
				label={t("dashboard.floor_create.draw_header")}
				onClose={props.onClose}
			/>

			<div className={styles.content}>
				<span className={styles.message}>
					{t("dashboard.floor_create.draw_prompt_choose_mode")}
				</span>
				<div className={styles.buttonRow}>
					<button
						className={classArr(
							styles.buttonBox,
							selection === "image" && styles.buttonBoxSelected,
						)}
						onClick={() => setSelection("image")}
					>
						<IconFloorplan2D />
						<span>
							{t("dashboard.floor_create.draw_prompt_place_2d")}
						</span>
					</button>
					<div className={styles.buttonSpacer} />
					<button
						className={classArr(
							styles.buttonBox,
							selection === "draw" && styles.buttonBoxSelected,
						)}
						onClick={() => setSelection("draw")}
					>
						<IconFloorplan3D />
						<span>
							{t("dashboard.floor_create.draw_prompt_trace_3d")}
						</span>
					</button>
				</div>

				<VelavuButton
					label={t("common.next")}
					onClick={handleSubmit}
					disabled={props.disableNext || selection === null}
					loadingIndicator={props.disableNext}
					fullWidth
				/>
			</div>
		</PinnedList>
	);
}
